import { catchError as rxjscatchError, map as rxjsmap, throwError as rxjsthrowError } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { BaseServices } from '../kuba.services';
import { ArchiveDocument } from '../manuals/models/manual-document.model';
import { TreeData } from './../common/models';
import { HttpClient } from '@angular/common/http';
import { SimpleDragAndDrop } from '../common/models/simple-drag-and-drop.model';

@Injectable()
export class ArchiveServices {
  constructor(private http: HttpClient) {}

  getArchiveTree(businessId: number): Observable<TreeData[]> {
    return this.http
      .get<
        any[]
      >(`${environment.BASE_URL}/archive/archivetreedata/${businessId}`).pipe(rxjsmap(result => result));
  }

  getArchiveTreeFolder(businessId: number): Observable<TreeData[]> {
    return this.http
      .get<
        any[]
      >(`${environment.BASE_URL}/archive/archivetreedatafolder/${businessId}`).pipe(rxjsmap(result => result));
  }

  // Add root folder
  createRootFolder(model: any, isRootFolder: any) {
    let sData = {
      BusinessId: +BaseServices.BusinessId ? +BaseServices.BusinessId : 0,
      FolderName: model.newNode.filename,
      ParentFolderId:
        model.parent.parentFolderId === 0 ? 1 : model.parent.parentFolderId,
      DocumentTypeId: model.parent.documentTypeId,
      Status: 1,
      IsDefault: model.newNode.IsDefault,
      IsCommon: false,
      Position: 0,
      CreatedBy: +BaseServices.UserId,
      ModifiedBy: +BaseServices.UserId
    };

    return this.http
      .post(`${environment.BASE_URL}/archive/new`, sData).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Add manual folder
  createManualFolder(model: any, isRootFolder: any) {
    let sData = {
      BusinessId: +BaseServices.BusinessId ? +BaseServices.BusinessId : 0,
      FolderName: model.newNode.filename,
      ParentFolderId: isRootFolder ? 0 : model.parent.nodeId,
      DocumentTypeId: model.parent.documentTypeId,
      Status: 1,
      IsDefault: model.newNode.IsDefault,
      IsCommon: false,
      Position: 0,
      CreatedBy: +BaseServices.UserId,
      ModifiedBy: +BaseServices.UserId
    };

    return this.http
      .post(`${environment.BASE_URL}/archive/new`, sData).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Rename Archive Folder
  renameManualFolder(model: any) {
    let sData = {
      Id: +model.item.data.nodeId,
      FolderName: model.item.data.filename,
      CreatedBy: +BaseServices.UserId
    };
    return this.http
      .put(`${environment.BASE_URL}/archive/renameFolder/${sData.Id}`, sData).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Delete Manual folder
  deleteManualFolder(did: any) {
    return this.http
      .post(`${environment.BASE_URL}/archive/deleteFolder/${did}`, '').pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  renameDocument(model: any) {
    let sData = {
      Id: +model.item.data.nodeId,
      FileName: model.item.data.filename,
      ModifiedBy: +BaseServices.UserId
    };
    return this.http
      .put(`${environment.BASE_URL}/archive/rename/${sData.Id}`, sData).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Delete document
  deleteDocument(did: any) {
    return this.http
      .delete(`${environment.BASE_URL}/archive/delete/${did}`).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  deleteMultipleDocument(data: any) {
    return this.http
      .put(`${environment.BASE_URL}/archive/deleteall`, data).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Delete Archive checklist
  deleteArchiveDocument(id: any) {
    return this.http
      .put(`${environment.BASE_URL}/archive/delete/archivechecklist/${id}`, {}).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  deleteArchiveCheckList(data: any) {
    return this.http
      .put(`${environment.BASE_URL}/archive/deleteAll/archivechecklist`, data).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Delete Archive checklist
  deleteFoodSafety(id: any) {
    return this.http
      .put(`${environment.BASE_URL}/foodsafety/deletefoodsafety/${id}`, {}).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  deleteMultipleFoodSafety(data: any) {
    return this.http
      .put(`${environment.BASE_URL}/foodsafety/delete/`, data).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  UpdateDocument(fileId: any, userId: any) {
    let sData = {};
    return this.http
      .put(
        `${environment.BASE_URL}/archive/updateDocument/${fileId}/${userId}`,
        sData
      ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  // Document related services
  // Archive Document
  addArchiveDocument(uploadedFile: any) {
    let archiveDocument: ArchiveDocument = new ArchiveDocument();
    archiveDocument.BusinessId = uploadedFile.BusinessId;
    archiveDocument.FeatureId = 0;
    archiveDocument.FeatureKey = 0;
    archiveDocument.ArchiveChecklistId = 0;
    archiveDocument.ArchiveFolderId = uploadedFile.ArchiveFolderId;
    archiveDocument.FileName = uploadedFile.filename;
    archiveDocument.OriginalFileName = uploadedFile.filename;
    archiveDocument.Size = uploadedFile.size;
    archiveDocument.MimeType = uploadedFile.mimetype;
    archiveDocument.Path = uploadedFile.path;
    archiveDocument.FileType = uploadedFile.fileTypeId;
    archiveDocument.Status = 1;
    archiveDocument.CreatedBy = uploadedFile.userId;
    return this.http
      .post(`${environment.BASE_URL}/archive/document/new`, archiveDocument).pipe(rxjsmap(result => result));
  }

  moveNode(model: any) {
    let dragAndDropRequest: SimpleDragAndDrop;
    const targetDocumentType = model.to?.parent?.data?.documentType;
    if (!targetDocumentType) {
      return rxjsthrowError('Invalid target document type');
    }
    switch (targetDocumentType) {
      case 'document':
        dragAndDropRequest = {
          SourceId: model.node.nodeId,
          IsFolder: model.node.type === 'folder' ? true : false,
          DestinationId: model.to.parent.data.nodeId
        };
        return this.http
          .put(
            `${environment.BASE_URL}/archive/DragAndDrop/document`,
            dragAndDropRequest
          ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
      default:
        return rxjsthrowError('Unsupported document type: ' + targetDocumentType);
    }
  }

  updateManualCheckboxstatus(data: any) {
    let sData = {
      Id: +data.nodeId,
      Status: +data.status,
      DocumentType: data.documentType.toLowerCase(),
      FileType: data.type.toLowerCase(),
      IsDefault: data.isDefault,
      BusinessId: BaseServices.BusinessId,
      AppId: BaseServices.ApplicationId
    };
    return this.http
      .put(
        `${environment.BASE_URL}/archive/ArchivePermission/${
          BaseServices.UserId
        }`,
        sData
      ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }
}
